export function secondsConversion(secs: number) {
    const h = Math.floor(secs / 3600);
    const m = Math.floor(secs % 3600 / 60);
    const s = Math.floor(secs % 3600 % 60);

    const hDisplay = h > 0 ? (h < 10 ? "0" + h + ":" : h + ":") : "00:";
    const mDisplay = m > 0 ? (m < 10 ? "0" + m + ":" : m + ":") : "00:";
    const sDisplay = s > 0 ? (s < 10 ? "0" + s : s) : "00";
    return hDisplay + mDisplay + sDisplay;
}

export function removePunctuation(str: string) {
    const punctuation = [".", ",", ":", ";", "-", "!", "?"];
    punctuation.forEach((char) => {
        str = str.replace(char, '');
    })
    return str
}

export function formatDate(date: Date | string | number): string {
    return new Date(date).toLocaleDateString('en-GB');
}